<template>
    <div class="pullNewBanner">
        <p class="countDown">
            活动倒计时：
            <span>{{time.d}}</span>天
            <span>{{time.h}}</span>:
            <span>{{time.m}}</span>:
            <span>{{time.s}}</span>
        </p>
        <img :src="activityPicture" alt="">
    </div>
</template>
<script>
import { timerCount } from '@/utils/tools';

export default {
  props: {
    activityInfo: {
      type: Object,
    },
  },
  data() {
    return {
      activityPicture: null,
      time: {},
      timer: null,
    };
  },
  created() {
    const { activityPicture, endTime } = this.activityInfo;
    this.activityPicture = activityPicture;
    this.countDown(endTime);
  },
  methods: {
    countDown(time) {
      const endTime = new Date(time.replace(/-/g, '/')).getTime();
      this.timer = null;
      this.timer = setInterval(() => {
        const now = new Date().getTime();
        if (now > endTime) { // 已结束去结束页面
          this.$router.replace({
            path: '/pullnew/over',
            query: {
              activityStatus: 9002,
            },
          });
        } else {
          this.time = timerCount(endTime - now, 2);
        }
      }, 1000);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    console.log('我清除了定时器');
  },
};
</script>
<style scoped lang="scss">
.pullNewBanner {
    position: relative;
    width: 100%;
    height: 500px;
    img {
        width: 100%;
        height: 100%;
    }
    .countDown {
        position: absolute;
        top: o;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 56px;
        color: #fff;
        font-size: 28px;
        background: rgba(0, 0, 0, 0.3);
        span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 32px;
            margin: 0 8px;
            color: #FF1A3F;
            font-size: 24px;
            background: #fff;
            border-radius: 8px;
        }
    }
}
</style>
